export class SnapshotFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "SnapshotDateFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
